const ENMetrics = {
	"Adicionar métrica": "Add metrica",
	"Nova métríca":"New metric",
	"Alterar métrica": "Change period metric",
	"O titulo da métrica é requerido":"Metric's title is required",
	"Data inicial do período é requerida":"Period's initial date is required",
	"Deseja realmente excluir métrica": "Do you really want to delete the metric",
	"Erro ao adicionar métrica": "Error on adding metric",
	"Erro ao alterar métrica": "Error on changing metric",
	"Erro ao excluir métrica": "Error on deleting metric",
	"Exclusão da métrica": "Delete metric",
	"Excluir período":"Delete period",
	"Descrição do tipo de período é requerida": "Period type's description is required",
	"Tipos de Período":"Period types",
	"Métrica adicionada com sucesso": "Metric successfully added",
	"Métrica alterada com sucesso": "Metric successfully changed",
	"Métrica excluída com sucesso": "Metric successfully deleted",
	"Codigo do período é requerido":"Period's code is required",
	"Descrição do período é requerida":"Period's description is required"
};

export default ENMetrics;
